<form (ngSubmit)="handleSubmit()" class="lg:px-2 space-y-4 pb-3">
  <!-- Calendar Selection - Horizontal Scrolling Buttons -->
  <div class="calendar-selection space-y-2">
    <label
      class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
    >
      <i class="pi pi-calendar text-xs"></i>
      {{ 'calendar.eventForm.selectCalendar' | transloco }}
      <span class="text-red-700 dark:text-red-400">*</span>
    </label>
    <div class="flex gap-2 overflow-x-auto p-2 scrollbar-hide">
      @for (calendar of calendars; track calendar.id) {
        <button
          type="button"
          (click)="selectCalendar(calendar.id)"
          [ngClass]="{
            'border-primary-500 bg-primary-50 dark:bg-primary-900/20 dark:border-primary-600':
              (selectedCalendarId() || _selectedCalendarId) === calendar.id,
            'hover:border-neutral-300 dark:hover:border-neutral-600 hover:bg-neutral-50 dark:hover:bg-neutral-700 border-neutral-300 dark:border-neutral-600':
              (selectedCalendarId() || _selectedCalendarId) !== calendar.id,
          }"
          class="calendar-button flex-shrink-0 px-2 py-1 rounded-lg border transition-all duration-200 flex items-center gap-2 text-xs cursor-pointer focus:outline-none focus:ring-0 bg-white dark:bg-neutral-800"
        >
          <div class="color-dot w-3 h-3 rounded" [style.background-color]="calendar.color"></div>
          <span
            class="text-sm font-medium text-neutral-700 dark:text-neutral-200 whitespace-nowrap"
            >{{ calendar.name }}</span
          >
        </button>
      }
    </div>
  </div>

  <!-- Title -->
  <div class="space-y-1">
    <label
      class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
    >
      <i class="pi pi-file text-xs"></i>
      {{ 'calendar.eventForm.title' | transloco }}
      <span class="text-red-700 dark:text-red-400">*</span>
    </label>
    <input
      type="text"
      [(ngModel)]="event.title"
      name="title"
      class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
      [placeholder]="'calendar.eventForm.enterEventTitle' | transloco"
    />
  </div>

  <!-- Description -->
  <div class="space-y-1">
    <label
      class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
    >
      <i class="pi pi-align-left rtl-flip text-xs"></i>
      {{ 'calendar.eventForm.description' | transloco }}
    </label>
    <textarea
      [(ngModel)]="event.description"
      name="description"
      rows="3"
      class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition resize-none placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
      [placeholder]="'calendar.eventForm.describeEvent' | transloco"
    ></textarea>
  </div>

  <!-- Color & Visibility -->
  <!-- <div class="grid grid-cols-2 gap-4 w-full">
        <div class="space-y-1 w-full">
            <label class="flex items-center gap-1.5 text-xs font-medium text-slate-600">
                <i class="pi pi-palette text-xs"></i>
                Color
            </label>
            <div class="flex gap-1.5 w-full">
                @for (color of colorOptions; track color.value) {
                  <button type="button" (click)="selectColor(color.value)" [class]="'w-6 h-6 rounded-md transition cursor-pointer ' + 
                    (event.color === color.value ? 'ring-2 ring-neutral-900 ring-offset-2' : 'hover:scale-110')"
                      [style.background-color]="color.value" [title]="color.label"></button>
                }
            </div>
        </div>
    </div> -->

  <!-- Start Date & Start Time -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="space-y-1">
      <label
        class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
      >
        <i class="pi pi-calendar text-xs"></i>
        {{ 'calendar.eventForm.startDate' | transloco }}
        <span class="text-red-700 dark:text-red-400">*</span>
      </label>
      <input
        type="date"
        [(ngModel)]="event.start_date"
        name="start_date"
        class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition"
      />
    </div>

    <div class="space-y-1">
      <label
        class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
      >
        <i class="pi pi-clock text-xs"></i>
        {{ 'calendar.eventForm.startTime' | transloco }}
      </label>
      <input
        type="time"
        [(ngModel)]="event.start_time"
        name="start_time"
        class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition"
      />
    </div>
  </div>

  <!-- End Date & End Time -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="space-y-1">
      <label
        class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
      >
        <i class="pi pi-calendar text-xs"></i>
        {{ 'calendar.eventForm.endDate' | transloco }}
      </label>
      <input
        type="date"
        [(ngModel)]="event.end_date"
        name="end_date"
        class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition"
      />
    </div>

    <div class="space-y-1">
      <label
        class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
      >
        <i class="pi pi-clock text-xs"></i>
        {{ 'calendar.eventForm.endTime' | transloco }}
      </label>
      <input
        type="time"
        [(ngModel)]="event.end_time"
        name="end_time"
        class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition"
      />
    </div>
  </div>

  <!-- Employees -->
  <div class="space-y-1">
    <label
      class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
    >
      <i class="pi pi-users text-xs"></i>
      {{ 'calendar.eventForm.employees' | transloco }}
    </label>
    <p-multiselect
      [options]="availableUsers"
      [(ngModel)]="selectedEmployees"
      name="employees"
      optionLabel="name"
      [placeholder]="'calendar.eventForm.selectEmployees' | transloco"
      [filter]="true"
      [showToggleAll]="true"
      display="chip"
      class="w-full"
    >
      <ng-template let-user #item>
        <div class="flex items-center gap-2">
          <img [src]="user.image" [alt]="user.name" class="w-6 h-6 rounded-full" />
          <div>
            <div class="font-medium text-sm text-neutral-900 dark:text-neutral-100">
              {{ user.name }}
            </div>
            <div class="text-xs text-neutral-500 dark:text-neutral-400">{{ user.email }}</div>
          </div>
        </div>
      </ng-template>
    </p-multiselect>
  </div>

  <!-- Address -->
  <div class="space-y-1">
    <label
      class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
    >
      <i class="pi pi-map-marker text-xs"></i>
      {{ 'calendar.eventForm.address' | transloco }}
    </label>
    <input
      type="text"
      [(ngModel)]="event.address"
      name="address"
      class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
      [placeholder]="'calendar.eventForm.enterLocationAddress' | transloco"
    />
  </div>

  <!-- Link -->
  <div class="space-y-1">
    <label
      class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
    >
      <i class="pi pi-link text-xs"></i>
      {{ 'calendar.eventForm.link' | transloco }}
    </label>
    <input
      type="url"
      [(ngModel)]="event.link"
      name="link"
      class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
      [placeholder]="'calendar.eventForm.linkPlaceholder' | transloco"
    />
  </div>

  <!-- Submit Button -->
  <div class="pt-2">
    <button
      type="submit"
      class="w-full px-4 py-2 bg-primary-500 hover:bg-primary-600 dark:bg-primary-600 dark:hover:bg-primary-500 text-white rounded-md transition text-sm font-medium flex items-center justify-center gap-2 shadow-sm"
    >
      <i class="pi pi-calendar"></i>
      {{ 'calendar.eventForm.createEvent' | transloco }}
    </button>
  </div>
</form>
